export default "__VITE_ASSET__B$i3ugPn__"